module.exports = __webpack_public_path__ + "tgm/img/cnt-judge.9298e4f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/index/cnt-judge.png
// module id = ++Lh
// module chunks = 1